// extracted by mini-css-extract-plugin
export default {"navItemTitle":"Navigation_navItemTitle__0Ca-Q"};